import { Component, OnInit, OnDestroy, ChangeDetectorRef, ViewChild, ViewChildren, AfterViewInit } from '@angular/core';
import { SessionService } from '../../../services/session.service';
import { MediaMatcher } from '@angular/cdk/layout';
import { ThemeManagerService } from 'src/app/services/theme-manager.service';
import { PlatformApiService } from 'src/app/services/platform-api.service';
import { GridSpinnerComponent } from 'src/app/shared/grid-spinner.component';
import { MatDialog } from '@angular/material/dialog';
import { SupportTicketComponent } from 'src/app/shared/support.component';
import { BillingContactComponent } from 'src/app/shared/billing-contact.component';
import { ConfirmationComponent } from 'src/app/shared/confirmation.component';
import { SettingsWizardComponent } from '../../settings-wizard/settings-wizard-dialog.component';
import { LoggerService } from 'src/app/services/logger.service';
import { MatSidenav } from '@angular/material/sidenav';
import { UserIdleService } from 'angular-user-idle';
import { Notification, NotificationType } from '../../../models/NotificationModel';
import { NotificationsComponent } from '../../account/notifications.component';
import { SplashScreenComponent } from '../../splash-screen/splash-screen.component';
import { RoleType } from "../../../models/AccountModel";

export enum StateList {
  LOADING,
  CONTINUEASSESSMENT,
  COMPLETEDASSESSMENT,
  CLOSEASSESSMENT,
  SHOWDASHBOARD,
  VIEWRESULTS
}

@Component({
  selector: 'cw-ci-side-nav-layout',
  templateUrl: './side-nav-layout.component.html',
  styleUrls: ['./side-nav-layout.component.scss']
})
export class SideNavLayoutComponent implements OnInit, OnDestroy, AfterViewInit {
  mobileQuery: MediaQueryList;
  RoleType = RoleType;

  private _mobileQueryListener: () => void;
  public selectedSubMenu = '';
  @ViewChild('spinner', { static: true }) spinner: GridSpinnerComponent;
  @ViewChild('notifications') notificationsComp: NotificationsComponent;

  constructor(private _userIdle: UserIdleService, private _logger: LoggerService, public sessionService: SessionService, private _platformApi: PlatformApiService, public themeManager: ThemeManagerService, private dialog: MatDialog, changeDetectorRef: ChangeDetectorRef, media: MediaMatcher) {
    this.mobileQuery = media.matchMedia('(max-width: 600px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);
  }

  ngOnDestroy(): void {
    this.mobileQuery.removeListener(this._mobileQueryListener);
  }

  ngAfterViewInit() {
    if (this.sessionService.hasFeature('ALLOW_SPLASH_SCREEN') &&
        this.sessionService.getCurrentUser().getPreference('ui.showSplashScreen').getBooleanValue()) {
      this.onShowSplashScreenClicked();
    }
  }

  ngOnInit() {
      // Start watching for user inactivity.
      this._userIdle.startWatching();

      // Start watching when user idle is starting.
      let timeoutPrompt;

      const timerSubscription = this._userIdle.onTimerStart().subscribe(count => {
        if (!timeoutPrompt) {
          timeoutPrompt = this.dialog.open(ConfirmationComponent, {
            panelClass: 'flush-dialog',
            data: {
              promptMessage: ['Your session is about to timeout due to inactivity. Do you want to stay logged in?'],
              promptTitle: 'Session Timeout',
              showClose: false,
              buttons: [{label:'Stay Logged In', value:true, color:'primary'}],
              height: 'auto'
            },
            disableClose: true
          });
          timeoutPrompt.afterClosed().subscribe(resp => {
            if (resp == true) {
              this._userIdle.resetTimer();
            }
            timeoutPrompt = undefined;
          });
        }
      });

      // Start watch when time is up.
      this._userIdle.onTimeout().subscribe(() => {
        if (timeoutPrompt) {
          timeoutPrompt.close();
        }

        timerSubscription.unsubscribe();
        this._userIdle.stopWatching();
        this.sessionService.handleSessionTimeout();
      });

      this._userIdle.ping$.subscribe(() => this.sessionService.refreshSessionData());
  }

  openSupport() {
    const dialogRef = this.dialog.open(SupportTicketComponent, {
      panelClass: 'flush-dialog'
    });
    dialogRef.afterClosed().subscribe();
  }

  buyNow() {
    const dialogRef = this.dialog.open(ConfirmationComponent, {
      panelClass: 'flush-dialog',
      data: {
        promptMessage: ['You are being redirected to our new ConnectWise payment system.',
                        'You will need to register for an account and confirm your registration before you complete your Identify purchase. Please be sure that you create this account with the same email address that you use to log into Identify.',
                        'For more detailed instructions, please refer to <a href="https://docs.connectwise.com/ConnectWise_Identify/006/ConnectWise_Identify_Purchase_Process" target="_blank">this University guide</a>.',
                        'Please note that after purchasing you will need to log out and log back in to Identify.'],
        promptTitle: 'Partner Portal Redirect'
      }
    });
    dialogRef.afterClosed().subscribe(resp => {
      if (resp == true) {
        this._logger.log('Trial user selected Buy Now');
        this.spinner.showSpinner('Redirecting to Partner Portal');
        this._platformApi.getReferralUrl(this.sessionService.getCurrentAccount().id).subscribe(rp => {
          window.open(rp, '_blank');
          this.spinner.hideSpinner();
        })
      }
    });
  }

  onMyProfileClicked() {
    const dialogRef = this.dialog.open(SettingsWizardComponent, {
      panelClass: 'flush-dialog',
      disableClose: true
    });
    dialogRef.afterClosed().subscribe();
  }

  onAccountSettingsClicked() {
    const dialogRef = this.dialog.open(SettingsWizardComponent, {
      panelClass: 'flush-dialog',
      disableClose: true,
      data: {
        startingMenuItem: 'ACCOUNT_START'
      }
    });
    dialogRef.afterClosed().subscribe();
  }

  onShowSplashScreenClicked() {
    const dialogRef = this.dialog.open(SplashScreenComponent, {
      panelClass: 'flush-dialog',
      autoFocus: false,
      disableClose: false
    });
    dialogRef.afterClosed().subscribe();
  }

  mostRecentSystemAlert(): Notification {
    const notifications = this.sessionService.getNotifications();
    if (notifications != undefined) {
      return notifications.find(el => el.type == NotificationType.SYSTEM_ALERT);
    } else {
      return undefined;
    }
  }

  displaySystemAlert() {
    this.notificationsComp.display(this.mostRecentSystemAlert());
  }

}
